// extracted by mini-css-extract-plugin
export default {"wrapper":"eF-z","button":"fF-z","alternate":"gF-z","disabled":"hF-z","paymentWarning":"iF-z","fadeIn":"jF-z"};